const validateRedirectUrl = redirect => {
  if (redirect.startsWith('/')) {
    window.location = decodeURIComponent(redirect);
    return true;
  } else {
    const decodedRedirect = decodeURIComponent(redirect);
    try {
      const redirectUrl = new URL(decodedRedirect, window.location.origin);
      if (redirectUrl.origin === window.location.origin) {
        window.location = redirectUrl.href;
        return true;
      }
    } catch (e) {
      console.error('Invalid URL:', e);
    }
  }
};

export function redirectToQueryParam({router, cms}) {
  const redirect = router.queryParams?.redirect;
  if (redirect) {
    if (cms) {
      validateRedirectUrl(redirect.replace('organization-login', ''));
    } else {
      validateRedirectUrl(redirect);
    }
  }
}

export function redirectToExplorer(router, views) {
  router.goTo(views.explorer, {});
}
